import React, { useState, useEffect } from 'react';
import { apiFetch } from './api';

const ProjektListe = ({ parentTyp, parentId, onOeffne }) => {
  const [projekte, setProjekte] = useState([]);
  const [neu, setNeu] = useState(false);
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(true);
  const [abgeschlossenOffen, setAbgeschlossenOffen] = useState(false);

  const [workflowPopup, setWorkflowPopup] = useState(false);
  const [workflows, setWorkflows] = useState([]);
  const [alleUsers, setAlleUsers] = useState([]);
  const [gewaehltWorkflow, setGewaehltWorkflow] = useState('');
  const [gewaehltWorkflowTasks, setGewaehltWorkflowTasks] = useState([]);
  const [workflowProjektName, setWorkflowProjektName] = useState('');
  const [workflowDeadline, setWorkflowDeadline] = useState('');
  const [taskZuweisungen, setTaskZuweisungen] = useState({});
  const [workflowLaedt, setWorkflowLaedt] = useState(false);

  const lade = async () => {
    const res = await apiFetch(`/projekte?parent_typ=${parentTyp}&parent_id=${parentId}`);
    const data = await res.json();
    setProjekte(data);
    setLoading(false);
  };

  const ladeWorkflows = async () => {
    const [wRes, uRes] = await Promise.all([
      apiFetch('/workflows'),
      apiFetch('/users')
    ]);
    setWorkflows(await wRes.json());
    setAlleUsers(await uRes.json());
  };

  useEffect(() => { lade(); }, [parentTyp, parentId]);

  const workflowWaehlen = async (workflowId) => {
    setGewaehltWorkflow(workflowId);
    setTaskZuweisungen({});
    if (!workflowId) { setGewaehltWorkflowTasks([]); return; }
    const res = await apiFetch(`/workflows/${workflowId}`);
    const data = await res.json();
    setGewaehltWorkflowTasks(data.tasks || []);
  };

  const workflowOeffnen = async () => {
    await ladeWorkflows();
    setGewaehltWorkflow('');
    setGewaehltWorkflowTasks([]);
    setWorkflowProjektName('');
    setWorkflowDeadline('');
    setTaskZuweisungen({});
    setWorkflowPopup(true);
  };

  const zuweisung = (taskId, userId) => {
    setTaskZuweisungen(prev => ({ ...prev, [taskId]: userId }));
  };

  const erstellen = async () => {
    if (!name) return;
    await apiFetch('/projekte', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, parent_typ: parentTyp, parent_id: parentId })
    });
    setName(''); setNeu(false);
    lade();
  };

  const workflowAnwenden = async () => {
    if (!gewaehltWorkflow || !workflowProjektName || !workflowDeadline) return;
    setWorkflowLaedt(true);
    const res = await apiFetch(`/workflows/${gewaehltWorkflow}/anwenden`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: workflowProjektName, deadline: workflowDeadline,
        parent_typ: parentTyp, parent_id: parentId, task_zuweisungen: taskZuweisungen
      })
    });
    const data = await res.json();
    setWorkflowLaedt(false);
    setWorkflowPopup(false);
    lade();
    if (data.id) onOeffne(data.id);
  };

  const statusFarbe = (status) => {
    const f = { offen: '#9b9b9b', 'in arbeit': '#1565c0', erledigt: '#2e7d32' };
    return f[status] || '#9b9b9b';
  };

  const offsetLabel = (offset) => {
    const n = Number(offset);
    if (n === 0) return 'Projekttag';
    if (n === -1) return '-1 Tag';
    if (n < 0) return `${n} Tage`;
    return `+${n} Tage`;
  };

  const inputStyle = {
    width: '100%', padding: '9px 12px', fontSize: '13px', border: '1px solid #e8e8e8',
    borderRadius: '8px', outline: 'none', boxSizing: 'border-box'
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: '500', color: '#6b6b6b',
    marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px'
  };

  const aktive = projekte.filter(p => p.status !== 'erledigt');
  const erledigte = projekte.filter(p => p.status === 'erledigt');

  const projektZeile = (p, ausgegraut = false) => (
    <div key={p.id} onClick={() => onOeffne(p.id)} style={{
      display: 'flex', alignItems: 'center', gap: '8px',
      padding: '8px 10px', backgroundColor: '#fafafa', borderRadius: '6px',
      cursor: 'pointer', fontSize: '13px',
      color: ausgegraut ? '#c4c4c4' : '#1a1a1a',
      opacity: ausgegraut ? 0.7 : 1
    }}>
      <span style={{
        width: '7px', height: '7px', borderRadius: '50%',
        backgroundColor: statusFarbe(p.status), flexShrink: 0
      }} />
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</span>
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {loading ? (
          <p style={{ fontSize: '12px', color: '#c4c4c4', margin: 0 }}>Lädt...</p>
        ) : aktive.length === 0 && erledigte.length === 0 ? (
          <p style={{ fontSize: '12px', color: '#c4c4c4', margin: '0 0 4px 0' }}>Noch keine Projekte</p>
        ) : (
          <>
            {aktive.map(p => projektZeile(p, false))}
            {erledigte.length > 0 && (
              <div style={{ marginTop: '4px' }}>
                <div
                  onClick={() => setAbgeschlossenOffen(!abgeschlossenOffen)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '5px',
                    padding: '5px 4px', cursor: 'pointer', fontSize: '11px', color: '#9b9b9b',
                    userSelect: 'none'
                  }}
                >
                  <span style={{ fontSize: '9px' }}>{abgeschlossenOffen ? '▾' : '▸'}</span>
                  <span>Abgeschlossen ({erledigte.length})</span>
                </div>
                {abgeschlossenOffen && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '4px' }}>
                    {erledigte.map(p => projektZeile(p, false))}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>

      {neu ? (
        <div style={{ marginTop: '8px' }}>
          <input type="text" value={name} autoFocus
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') erstellen(); if (e.key === 'Escape') { setNeu(false); setName(''); } }}
            placeholder="Projektname..."
            style={{
              width: '100%', padding: '8px 10px', fontSize: '13px', border: '1px solid #e8e8e8',
              borderRadius: '6px', outline: 'none', boxSizing: 'border-box', marginBottom: '6px'
            }}
          />
          <div style={{ display: 'flex', gap: '6px' }}>
            <button onClick={erstellen} style={{
              padding: '5px 12px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
              borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer'
            }}>Anlegen</button>
            <button onClick={() => { setNeu(false); setName(''); }} style={{
              padding: '5px 12px', backgroundColor: 'transparent', color: '#9b9b9b',
              border: '1px solid #e8e8e8', borderRadius: '6px', fontSize: '12px', cursor: 'pointer'
            }}>Abbrechen</button>
          </div>
        </div>
      ) : (
        <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <button onClick={() => setNeu(true)} style={{
            width: '100%', padding: '8px', backgroundColor: 'transparent',
            color: '#6b6b6b', border: '1px dashed #d4d4d4', borderRadius: '6px',
            fontSize: '12px', cursor: 'pointer'
          }}>+ Neues Projekt</button>
          <button onClick={workflowOeffnen} style={{
            width: '100%', padding: '8px', backgroundColor: 'transparent',
            color: '#6b6b6b', border: '1px dashed #d4d4d4', borderRadius: '6px',
            fontSize: '12px', cursor: 'pointer'
          }}>⟳ Aus Workflow erstellen</button>
        </div>
      )}

      {workflowPopup && (
        <div onClick={() => setWorkflowPopup(false)} style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.35)', display: 'flex',
          alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000,
          padding: '40px 20px', overflowY: 'auto'
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            backgroundColor: '#ffffff', borderRadius: '14px', width: '100%', maxWidth: '520px',
            padding: '32px', boxShadow: '0 12px 48px rgba(0,0,0,0.18)'
          }}>
            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 24px 0', letterSpacing: '-0.3px' }}>
              Projekt aus Workflow erstellen
            </h3>

            <div style={{ marginBottom: '16px' }}>
              <label style={labelStyle}>Workflow</label>
              {workflows.length === 0 ? (
                <p style={{ fontSize: '13px', color: '#c4c4c4' }}>Keine Workflows vorhanden.</p>
              ) : (
                <select value={gewaehltWorkflow} onChange={(e) => workflowWaehlen(e.target.value)}
                  style={{ ...inputStyle, cursor: 'pointer' }}>
                  <option value="">Workflow wählen...</option>
                  {workflows.map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
                </select>
              )}
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={labelStyle}>Projektname</label>
              <input type="text" value={workflowProjektName}
                onChange={(e) => setWorkflowProjektName(e.target.value)}
                placeholder="z.B. Folge 48 – Gast XY" style={inputStyle} />
            </div>

            <div style={{ marginBottom: gewaehltWorkflowTasks.length > 0 ? '24px' : '8px' }}>
              <label style={labelStyle}>Projektdeadline</label>
              <input type="date" value={workflowDeadline}
                onChange={(e) => setWorkflowDeadline(e.target.value)} style={inputStyle} />
            </div>

            {gewaehltWorkflowTasks.length > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <label style={{ ...labelStyle, marginBottom: '12px' }}>
                  Wer macht was? <span style={{ color: '#c4c4c4', fontWeight: '400', textTransform: 'none', letterSpacing: 0 }}>(optional)</span>
                </label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {gewaehltWorkflowTasks.map(t => (
                    <div key={t.id} style={{
                      display: 'flex', alignItems: 'center', gap: '12px',
                      padding: '10px 12px', backgroundColor: '#fafafa', borderRadius: '8px'
                    }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '13px', fontWeight: '500', color: '#1a1a1a', marginBottom: '1px' }}>{t.name}</div>
                        <div style={{ fontSize: '11px', color: '#c4c4c4' }}>{offsetLabel(t.deadline_offset)}</div>
                      </div>
                      <select value={taskZuweisungen[t.id] || ''}
                        onChange={(e) => zuweisung(t.id, e.target.value)}
                        style={{
                          padding: '6px 10px', fontSize: '12px', border: '1px solid #e8e8e8',
                          borderRadius: '6px', outline: 'none', backgroundColor: '#fff',
                          color: taskZuweisungen[t.id] ? '#1a1a1a' : '#9b9b9b', cursor: 'pointer', minWidth: '150px'
                        }}>
                        <option value="">Niemand zugewiesen</option>
                        {alleUsers.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                      </select>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={workflowAnwenden}
                disabled={!gewaehltWorkflow || !workflowProjektName || !workflowDeadline || workflowLaedt}
                style={{
                  padding: '10px 20px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
                  borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                  opacity: (!gewaehltWorkflow || !workflowProjektName || !workflowDeadline) ? 0.4 : 1
                }}>
                {workflowLaedt ? 'Erstelle...' : 'Projekt erstellen'}
              </button>
              <button onClick={() => setWorkflowPopup(false)} style={{
                padding: '10px 20px', backgroundColor: 'transparent', color: '#6b6b6b',
                border: '1px solid #e8e8e8', borderRadius: '8px', fontSize: '13px', cursor: 'pointer'
              }}>Abbrechen</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjektListe;